import { client, applePay } from 'braintree-web';

const isAppleWalletSetUp = (authorizationKey) => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined') {
      client
        .create({
          authorization: authorizationKey,
        })
        .then((clientInstance) => {
          return Promise.all([
            applePay.create({
              client: clientInstance,
            }),
          ]);
        })
        .then(([applePayInstanceRef]) => {
          const promise = window?.ApplePaySession?.canMakePaymentsWithActiveCard(
            applePayInstanceRef?.merchantIdentifier
          );
          if (window?.ApplePaySession) {
            promise.then((canMakePayments) => {
              if (canMakePayments) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(false);
          }
        })
        .catch(() => resolve(false));
    }
  });
};

export default isAppleWalletSetUp;
